var _path, _g, _path2, _g2, _path3, _path4, _g3, _path5, _path6, _g4, _path7, _path8, _g5, _path9, _path0, _g6, _path1, _path10, _g7, _path11, _path12, _g8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShiftFourSlotsThreeTaken = function SvgShiftFourSlotsThreeTaken(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 36 18"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "ShiftFourSlotsThreeTaken_svg__a",
    width: 10,
    height: 11,
    x: 27,
    y: 7,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36 17.995v-8.5c-1.667-2.5-7-2.5-9 0v8.5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ShiftFourSlotsThreeTaken_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1A1",
    d: "M36 9.495h2v-.606l-.336-.504zm0 8.5v2h2v-2zm-9 0h-2v2h2zm0-8.5-1.561-1.25-.438.548v.701zm7 0v8.5h4v-8.5zm2 6.5h-9v4h9zm-9 2h2v-8.5h-4v8.5zm10.664-9.61c-1.361-2.041-3.923-2.765-6.039-2.765-2.148 0-4.674.734-6.186 2.626l3.123 2.498c.487-.608 1.627-1.124 3.063-1.124 1.467 0 2.406.526 2.712.985z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ShiftFourSlotsThreeTaken_svg__b",
    width: 7,
    height: 7,
    x: 28,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35 3.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ShiftFourSlotsThreeTaken_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1A1",
    d: "M33 3.5A1.5 1.5 0 0 1 31.5 5v4A5.5 5.5 0 0 0 37 3.5zM31.5 5A1.5 1.5 0 0 1 30 3.5h-4A5.5 5.5 0 0 0 31.5 9zM30 3.5A1.5 1.5 0 0 1 31.5 2v-4A5.5 5.5 0 0 0 26 3.5zM31.5 2A1.5 1.5 0 0 1 33 3.5h4A5.5 5.5 0 0 0 31.5-2z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A4A4A",
    d: "M9 18V9.498c-1.667-2.501-7-2.501-9 0V18z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ShiftFourSlotsThreeTaken_svg__c",
    width: 10,
    height: 11,
    x: 0,
    y: 7,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9 18V9.498c-1.667-2.501-7-2.501-9 0V18z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ShiftFourSlotsThreeTaken_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A4A4A",
    d: "M9 9.498h2v-.606l-.336-.504zM9 18v2h2v-2zm-9 0h-2v2h2zm0-8.502-1.561-1.25-.438.548v.701zm7 0V18h4V9.498zm2 6.501H0v4.002h9zM0 18h2V9.497h-4V18zm10.664-9.612c-1.362-2.043-3.923-2.766-6.04-2.766-2.147 0-4.673.734-6.185 2.626l3.123 2.5c.487-.61 1.627-1.125 3.063-1.125 1.467 0 2.406.526 2.711.985z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A4A4A",
    d: "M8 3.501a3.5 3.5 0 1 1-7.001.001 3.5 3.5 0 0 1 7-.001"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ShiftFourSlotsThreeTaken_svg__d",
    width: 7,
    height: 8,
    x: 1,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 3.501a3.5 3.5 0 1 1-7.001.001 3.5 3.5 0 0 1 7-.001"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ShiftFourSlotsThreeTaken_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A4A4A",
    d: "M6 3.501a1.5 1.5 0 0 1-1.5 1.5v4.001A5.5 5.5 0 0 0 10 3.501zm-1.5 1.5a1.5 1.5 0 0 1-1.5-1.5h-4a5.5 5.5 0 0 0 5.5 5.501zM3 3.501a1.5 1.5 0 0 1 1.5-1.5v-4.002A5.5 5.5 0 0 0-1 3.501zm1.5-1.5A1.5 1.5 0 0 1 6 3.5h4a5.5 5.5 0 0 0-5.5-5.502z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A4A4A",
    d: "M18 18V9.498c-1.667-2.501-7-2.501-9 0V18z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ShiftFourSlotsThreeTaken_svg__e",
    width: 10,
    height: 11,
    x: 9,
    y: 7,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18 18V9.498c-1.667-2.501-7-2.501-9 0V18z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ShiftFourSlotsThreeTaken_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A4A4A",
    d: "M18 9.498h2v-.606l-.336-.504zM18 18v2h2v-2zm-9 0H7v2h2zm0-8.502L7.44 8.248 7 8.796v.701zm7 0V18h4V9.498zm2 6.501H9v4.002h9zM9 18h2V9.497H7V18zm10.664-9.612c-1.362-2.043-3.923-2.766-6.04-2.766-2.147 0-4.673.734-6.185 2.626l3.123 2.5c.487-.61 1.627-1.125 3.063-1.125 1.467 0 2.406.526 2.711.985z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A4A4A",
    d: "M17 3.501a3.5 3.5 0 1 1-7.001.001 3.5 3.5 0 0 1 7-.001"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ShiftFourSlotsThreeTaken_svg__f",
    width: 7,
    height: 8,
    x: 10,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17 3.501a3.5 3.5 0 1 1-7.001.001 3.5 3.5 0 0 1 7-.001"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ShiftFourSlotsThreeTaken_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A4A4A",
    d: "M15 3.501a1.5 1.5 0 0 1-1.5 1.5v4.001A5.5 5.5 0 0 0 19 3.501zm-1.5 1.5a1.5 1.5 0 0 1-1.5-1.5H8a5.5 5.5 0 0 0 5.5 5.501zm-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5v-4.002A5.5 5.5 0 0 0 8 3.501zm1.5-1.5A1.5 1.5 0 0 1 15 3.5h4a5.5 5.5 0 0 0-5.5-5.502z"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A4A4A",
    d: "M27 18V9.498c-1.667-2.501-7-2.501-9 0V18z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ShiftFourSlotsThreeTaken_svg__g",
    width: 10,
    height: 11,
    x: 18,
    y: 7,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27 18V9.498c-1.667-2.501-7-2.501-9 0V18z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ShiftFourSlotsThreeTaken_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A4A4A",
    d: "M27 9.498h2v-.606l-.336-.504zM27 18v2h2v-2zm-9 0h-2v2h2zm0-8.502-1.561-1.25-.438.548v.701zm7 0V18h4V9.498zm2 6.501h-9v4.002h9zM18 18h2V9.497h-4V18zm10.664-9.612c-1.362-2.043-3.923-2.766-6.04-2.766-2.147 0-4.673.734-6.185 2.626l3.123 2.5c.487-.61 1.627-1.125 3.063-1.125 1.467 0 2.406.526 2.711.985z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A4A4A",
    d: "M26 3.501a3.5 3.5 0 1 1-7.001.001 3.5 3.5 0 0 1 7-.001"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ShiftFourSlotsThreeTaken_svg__h",
    width: 7,
    height: 8,
    x: 19,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26 3.501a3.5 3.5 0 1 1-7.001.001 3.5 3.5 0 0 1 7-.001"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ShiftFourSlotsThreeTaken_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A4A4A",
    d: "M24 3.501a1.5 1.5 0 0 1-1.5 1.5v4.001A5.5 5.5 0 0 0 28 3.501zm-1.5 1.5a1.5 1.5 0 0 1-1.5-1.5h-4a5.5 5.5 0 0 0 5.5 5.501zm-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5v-4.002A5.5 5.5 0 0 0 17 3.501zm1.5-1.5A1.5 1.5 0 0 1 24 3.5h4a5.5 5.5 0 0 0-5.5-5.502z"
  }))));
};
export default SvgShiftFourSlotsThreeTaken;